/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateOrganization = /* GraphQL */ `
  subscription OnCreateOrganization {
    onCreateOrganization {
      id
      companyName
      tier
      stripeSubId
      stripeCustomerId
      administrator
      members
      requireMfaForVaultAccess
      singleSignOnEnabled
      termsEnforced
      passwordControlRequirements
      deviceLimitPerUser
      allowMembersToJoinOtherVaults
      enableComments
      enableFileRequests
      limitMemberSessionTimeoutLength
    }
  }
`;
export const onUpdateOrganization = /* GraphQL */ `
  subscription OnUpdateOrganization {
    onUpdateOrganization {
      id
      companyName
      tier
      stripeSubId
      stripeCustomerId
      administrator
      members
      requireMfaForVaultAccess
      singleSignOnEnabled
      termsEnforced
      passwordControlRequirements
      deviceLimitPerUser
      allowMembersToJoinOtherVaults
      enableComments
      enableFileRequests
      limitMemberSessionTimeoutLength
    }
  }
`;
export const onDeleteOrganization = /* GraphQL */ `
  subscription OnDeleteOrganization {
    onDeleteOrganization {
      id
      companyName
      tier
      stripeSubId
      stripeCustomerId
      administrator
      members
      requireMfaForVaultAccess
      singleSignOnEnabled
      termsEnforced
      passwordControlRequirements
      deviceLimitPerUser
      allowMembersToJoinOtherVaults
      enableComments
      enableFileRequests
      limitMemberSessionTimeoutLength
    }
  }
`;

export const onVaultPresenceChange = /* GraphQL */ `
  subscription OnVaultPresenceChange($vault_id: ID!) {
    onVaultPresenceChange(vault_id: $vault_id) {
      vault_id
      session_id
      user_id
      user_name
      user_email
      status
      last_heartbeat
      joined_at
    }
  }
`;

export const onWebRTCSignal = /* GraphQL */ `
  subscription OnWebRTCSignal($vault_id: ID!, $to_user_id: ID!) {
    onWebRTCSignal(vault_id: $vault_id, to_user_id: $to_user_id) {
      vault_id
      from_user_id
      from_user_name
      to_user_id
      signal_type
      signal_data
      timestamp
    }
  }
`;